import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJacketedMixingVessel = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100.17,
	height: 174.5,
	viewBox: "0 0 100.17 174.5",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 10.08 100.0 L 0.08 110.0 L 0.08 145.0 A 50.0 30.0 0.0 0 0 40.08 174.5 L 46.08 165.0 Z M 90.08 100.0 L 100.08 110.0 L 100.08 145.0 A 50.0 30.0 0.0 0 1 60.08 174.5 L 54.08 165.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 10.08 50.0 A 40.0 15.0 0.0 1 1 90.08 50.0 L 90.08 140.0 A 40.0 25.0 0.0 1 1 10.08 140.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 45.08,
			y: 0,
			width: 10,
			height: 20,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 43.08 3.0 L 57.08 3.0 M 43.08 17.0 L 57.08 17.0 M 50.08 20.0 L 50.08 150.5",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 40.08,
			cy: 150,
			rx: 10,
			ry: 3,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 60.08,
			cy: 150,
			rx: 10,
			ry: 3,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgJacketedMixingVessel;
